import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
export const WitnessWithdrawPay = ({
  op,
  current,
  linkToAccount,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    if (current === op[1].witness_account) {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.witness_pay"
      }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
        style: {
          fontWeight: "bold"
        },
        amount: op[1].amount,
        asset: "1.3.0"
      }), /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.to"
      }), "\xA0", linkToAccount(op[1].witness_account));
    } else {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.received"
      }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
        style: {
          fontWeight: "bold"
        },
        amount: op[1].amount,
        asset: "1.3.0"
      }), /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "proposal.from"
      }), "\xA0", linkToAccount(op[1].witness_account));
    }
  } else {
    if (current === op[1].witness_account) {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "transaction.witness_pay"
      }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
        amount: op[1].amount,
        asset: "1.3.0"
      }), /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "transaction.to"
      }), "\xA0", linkToAccount(op[1].witness_account));
    } else {
      return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "transaction.received"
      }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
        amount: op[1].amount,
        asset: "1.3.0"
      }), /*#__PURE__*/React.createElement(Translate, {
        component: "span",
        content: "transaction.from"
      }), "\xA0", linkToAccount(op[1].witness_account));
    }
  }
};